const types = {
	//Get Template name
	GET_INTER_LAB_PROGRAM_START: "GET_INTER_LAB_PROGRAM_START",
	GET_INTER_LAB_PROGRAM_SUCCESS: "GET_INTER_LAB_PROGRAM_SUCCESS",
	GET_INTER_LAB_PROGRAM_ERROR: "GET_INTER_LAB_PROGRAM_ERROR",
	GET_INTER_LAB_PROGRAM_RESET: "GET_INTER_LAB_PROGRAM_RESET",

	//Create Template name
	CREATE_INTER_LAB_PROGRAM_START: "CREATE_INTER_LAB_PROGRAM_START",
	CREATE_INTER_LAB_PROGRAM_SUCCESS: "CREATE_INTER_LAB_PROGRAM_SUCCESS",
	CREATE_INTER_LAB_PROGRAM_ERROR: "CREATE_INTER_LAB_PROGRAM_ERROR",
	CREATE_INTER_LAB_PROGRAM_RESET: "CREATE_INTER_LAB_PROGRAM_RESET",

	//delete Template name
	DELETE_INTER_LAB_PROGRAM_START: "DELETE_INTER_LAB_PROGRAM_START",
	DELETE_INTER_LAB_PROGRAM_SUCCESS: "DELETE_INTER_LAB_PROGRAM_SUCCESS",
	DELETE_INTER_LAB_PROGRAM_ERROR: "DELETE_INTER_LAB_PROGRAM_ERROR",
	DELETE_INTER_LAB_PROGRAM_RESET: "DELETE_INTER_LAB_PROGRAM_RESET",

	//update Template name
	UPDATE_INTER_LAB_PROGRAM_START: "UPDATE_INTER_LAB_PROGRAM_START",
	UPDATE_INTER_LAB_PROGRAM_SUCCESS: "UPDATE_INTER_LAB_PROGRAM_SUCCESS",
	UPDATE_INTER_LAB_PROGRAM_ERROR: "UPDATE_INTER_LAB_PROGRAM_ERROR",
	UPDATE_INTER_LAB_PROGRAM_RESET: "UPDATE_INTER_LAB_PROGRAM_RESET",

	//single item  name
	SINGLE_INTER_LAB_PROGRAM_START: "SINGLE_INTER_LAB_PROGRAM_START",
	SINGLE_INTER_LAB_PROGRAM_SUCCESS: "SINGLE_INTER_LAB_PROGRAM_SUCCESS",
	SINGLE_INTER_LAB_PROGRAM_ERROR: "SINGLE_INTER_LAB_PROGRAM_ERROR",
	SINGLE_INTER_LAB_PROGRAM_RESET: "SINGLE_INTER_LAB_PROGRAM_RESET",
};

export default types;
